interface ServiceCardProps {
  service: {
    id: number;
    title: string;
    description: string;
    icon: string;
    image: string;
  };
  onClick: () => void;
}

const ServiceCard = ({ service, onClick }: ServiceCardProps) => {
  return (
    <div 
      className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group"
      onClick={onClick}
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
        <div className="absolute bottom-4 left-4">
          <div className="w-12 h-12 bg-white/90 rounded-lg flex items-center justify-center">
            <i className={`${service.icon} text-2xl text-blue-600`}></i>
          </div>
        </div>
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
          {service.title}
        </h3>
        <p className="text-gray-600 mb-4 line-clamp-3">
          {service.description}
        </p>
        <div className="flex items-center text-blue-600 font-medium group-hover:text-blue-700">
          <span className="whitespace-nowrap">Learn More</span>
          <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;